import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { API_CONFIG } from '../config/api';
// import { useNavigate } from 'react-router-dom';

// The setIsAuthenticated function is now passed as a prop
const LoginPage = ({ setIsAuthenticated }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    // const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        try {
            const response = await fetch(API_CONFIG.ENDPOINTS.LOGIN, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username, password }),
            });

            const data = await response.json();

            if (response.ok) {
                // Store the JWT and user data
                localStorage.setItem('token', data.token);
                localStorage.setItem('user', JSON.stringify(data.user));
                try {
                    const name = (data.user && (data.user.first_name || data.user.username)) || '';
                    sessionStorage.setItem('welcomeName', name);
                    sessionStorage.setItem('welcomePending', '1');
                } catch {}

                // Call the function from App.js to update the state
                setIsAuthenticated(true);
                
                // We no longer need this navigate call, as App.js will handle the redirect
                // navigate('/dashboard'); 
            } else {
                setError(data.message || 'Login failed.');
            }
        } catch (err) {
            setError('An error occurred. Please try again.');
        }
    };

    const [companyName, setCompanyName] = useState('Medic');
    React.useEffect(() => {
        (async () => {
            try {
                const res = await fetch(API_CONFIG.ENDPOINTS.COMPANY_INFO);
                if (!res.ok) return;
                const data = await res.json();
                if (data?.name) setCompanyName(data.name);
            } catch {}
        })();
    }, []);

    return (
        <div className="min-h-[80vh] flex items-center justify-center px-4">
            <div className="w-full max-w-md bg-white border border-gray-200 rounded-2xl shadow-sm p-6 md:p-8">
                <div className="text-center mb-6">
                    <h1 className="text-3xl font-semibold text-gray-900">{companyName || 'Medic'} Panel Login</h1>
                    <p className="text-sm text-gray-600 mt-1">Prijavite se da nastavite</p>
                </div>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Korisničko ime</label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            className="mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 px-3 py-3"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Lozinka</label>
                        <div className="relative mt-1">
                            <input
                                type={showPassword ? 'text' : 'password'}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                className="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 px-3 py-3 pr-10"
                            />
                            <button
                                type="button"
                                className="absolute inset-y-0 right-0 px-3 text-gray-500 hover:text-gray-700"
                                onClick={() => setShowPassword((v) => !v)}
                                aria-label={showPassword ? 'Sakrij lozinku' : 'Prikaži lozinku'}
                                title={showPassword ? 'Sakrij lozinku' : 'Prikaži lozinku'}
                            >
                                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                            </button>
                        </div>
                        
                    </div>
                    {error && <div className="p-3 text-sm text-red-700 bg-red-100 rounded-md">{error}</div>}
                    <button type="submit" className="w-full py-3 rounded-md bg-blue-600 text-white hover:bg-blue-700 transition-colors">Prijavi se</button>
                    <div className="text-center">
                        <a href="/forgot-password" className="inline-block mt-3 text-sm text-blue-600 hover:underline">Zaboravili ste lozinku?</a>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LoginPage;
